import { render } from "./CRMShippingRankingView.vue?vue&type=template&id=95b99b44"
import script from "./CRMShippingRankingView.vue?vue&type=script&lang=js"
export * from "./CRMShippingRankingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__